import { render, staticRenderFns } from "./SelectedAnswers.vue?vue&type=template&id=634ccc18"
import script from "./SelectedAnswers.vue?vue&type=script&lang=js"
export * from "./SelectedAnswers.vue?vue&type=script&lang=js"
import style0 from "./SelectedAnswers.vue?vue&type=style&index=0&id=634ccc18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports